// Export the current filter group as CSV (W1-B-15).
// Capped at 5000 rows server-side; we surface a toast if X-Truncated.
import { useState } from "react";
import { exportContactsCsv } from "../../lib/api";
import { useExplorerStore } from "../../store/explorerStore";
import { useToastStore } from "../../store/toastStore";

function triggerDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  // Defer revoke so the browser has time to start the download.
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export function ExportCsvButton() {
  const filterGroup = useExplorerStore((s) => s.filterGroup);
  const pushToast = useToastStore((s) => s.push);
  const [busy, setBusy] = useState(false);

  async function onClick(): Promise<void> {
    if (busy) return;
    setBusy(true);
    try {
      const result = await exportContactsCsv({ filterGroup });
      triggerDownload(result.blob, result.filename);
      if (result.truncated) {
        pushToast({
          variant: "warning",
          message: `Export capped at 5000 rows (${result.totalMatched} matched). Narrow your filters to export the rest.`,
        });
      } else {
        pushToast({
          variant: "success",
          message: `Exported ${result.totalMatched} contact${result.totalMatched === 1 ? "" : "s"} to CSV.`,
        });
      }
    } catch (err) {
      pushToast({
        variant: "error",
        message: `Export failed: ${err instanceof Error ? err.message : String(err)}`,
      });
    } finally {
      setBusy(false);
    }
  }

  return (
    <button
      type="button"
      className="export-csv-button"
      onClick={onClick}
      disabled={busy}
      aria-label="Export filtered contacts as CSV"
      title="Export current results to CSV (max 5000 rows)"
    >
      {busy ? "Exporting…" : "Export CSV"}
    </button>
  );
}
